class FiskalyEsController extends AbstractIntegrationController
	@register()
	@inject 'configuration',
		'configurationOptions'
		'Shops'
		'vatRates'
		'IntegrationRepository'
		'RenderRepository'

	integrationId: 'fiskaly_es'

	initialize: ->
		if _.isEmpty(@configuration.shops) then @configuration.shops = {}

		@shops = _.map @Shops.data, (shop) =>
			shopConfiguration = @configuration.shops[shop.id]
			shop.is_selected = shopConfiguration?

			return shop

		@signedAgreementFiles = {}

	save: ->
		super(@configuration).then (response) =>
			@configuration = response.data

			if _.isEmpty(@configuration.shops) then @configuration.shops = {}

	afterDisconnect: ->
		@shops = _.map @shops, (shop) =>
			shop.is_selected = false

			return shop

		@configuration.shops = {}

	addShop: (shop) ->
		shop.is_selected = true

		@mainForm.$setDirty()

	removeShop: (shop) ->
		shop.is_selected = false

		delete @configuration.shops[shop.id]

		@mainForm.$setDirty()

	uploadSignedAgreement: (shop) ->
		signedAgreementFile = @signedAgreementFiles[shop.id]

		@IntegrationRepository
			.uploadFile "#{@integrationId}/shops/#{shop.id}/agreement", {file: signedAgreementFile}
			.then =>
				@signedAgreementFiles[shop.id] = null
				@configuration.shops[shop.id].has_uploaded_signed_agreement = true

	generateAgreement: (shop) ->
		@RenderRepository.downloadFromUrl @IntegrationRepository.toString(null, "/#{@integrationId}/shops/#{shop.id}/agreement")
